import { UsercentricsScript, UsercentricsScriptProps } from '../tracking.model';
/**
 *
 * @param uc
 * @returns Returns CMP Script Tag to easily control scripts implemented on the website and manage consent settings of the users.
 */
const script = (uc: UsercentricsScriptProps): UsercentricsScript => {
  return {
    src: 'https://app.usercentrics.eu/browser-ui/latest/loader.js',
    id: uc.id ?? 'usercentrics-cmp',
    type: 'application/javascript',
    'data-settings-id': uc.ucId,
    defer: uc.defer ?? true,
    async: uc.async ?? true,
    mode: 'client',
  };
};

export default script;
